import AccountPlanType from "./AccountPlanType";

class AccountPlanTypeClass {
  constructor(private readonly _value: AccountPlanType = AccountPlanType.PLAN_NONE) {
  }

  get value() {
    return this._value;
  }
}

export default AccountPlanTypeClass;
